import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import ConsumerBreadcrumb, { BreadcrumbPlaceholder } from './ConsumerBreadcrumb';
const ADMIN_PROPS = {
  config: {
    items: [{
      label: 'Home',
      link: '/shop'
    }, {
      label: 'Living Room Furniture',
      link: '/living-room-furniture/'
    }]
  },
  location: {
    pathname: '/',
    search: '',
    hash: '',
    state: {},
    key: 'is-admin-miomyf'
  },
  color: 'light',
  forPage: 'Home'
};
const ConsumerBreadcrumbWrapper = t0 => {
  const $ = _c(11);
  const {
    isAdmin: t1,
    config: t2,
    layout,
    color,
    forPage
  } = t0;
  const isAdmin = t1 === undefined ? false : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {
      items: [],
      productVisualization: false
    } : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const config = t3;
  const location = useLocation();
  let t4;
  if ($[2] !== color || $[3] !== config || $[4] !== forPage || $[5] !== isAdmin || $[6] !== layout || $[7] !== location) {
    t4 = isAdmin ? ADMIN_PROPS : {
      config,
      location,
      layout,
      color,
      forPage
    };
    $[2] = color;
    $[3] = config;
    $[4] = forPage;
    $[5] = isAdmin;
    $[6] = layout;
    $[7] = location;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const props = t4;
  let t5;
  if ($[9] !== props) {
    t5 = <ConsumerBreadcrumb {...props} />;
    $[9] = props;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
ConsumerBreadcrumbWrapper.propTypes = {
  isAdmin: PropTypes.bool,
  color: PropTypes.string,
  config: PropTypes.shape({
    categoryId: PropTypes.number,
    collectionId: PropTypes.number,
    items: PropTypes.arrayOf(PropTypes.shape({
      link: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })),
    productId: PropTypes.number,
    productVisualization: PropTypes.bool,
    variantId: PropTypes.string
  }),
  forPage: PropTypes.string,
  layout: PropTypes.string
};
export { BreadcrumbPlaceholder };
export default ConsumerBreadcrumbWrapper;